import { environment } from 'src/environments/environment';

export class LogService {
  private static readonly canLog = environment.showLogs;

  static info(...args: any[]): void {
    if (!LogService.canLog) return;

    console.log(
      '%c[LOG]',
      'color: #2196F3; font-weight: bold;',
      ...args
    );
  }

  static warn(...args: any[]): void {
    if (!LogService.canLog) return;

    console.warn(
      '%c[WARN]',
      'color: #FF9800; font-weight: bold;',
      ...args
    );
  }

  static error(...args: any[]): void {
    if (!LogService.canLog) return;

    console.error(
      '%c[ERROR]',
      'color: #f44336; font-weight: bold;',
      ...args
    );
  }
}
